const invoice = {
  state: {
    formData: null,
    invoiceStep: 1
  },
  mutations: {
    setStep(state, step) {
      state.invoiceStep = step
    },
    setFormData(state, data) {
      state.formData = data
    },
    unsetInvoice(state) {
      state.formData = null
      state.invoiceStep = 1
    }
  },
  actions: {
    setStep(context, data) {
      let step
      switch (data) {
        case 'basic-info':
          step = 1
          break
        case 'shipping-details':
          step = 2
          break
        case 'funding-details':
          step = 3
          break
        case 'upload-docs':
          step = 4
          break
        case 'review':
          step = 5
          break
      }
      context.commit('setStep', step)
    },
    setFormData(context, data) {
      context.commit('setFormData', data)
    },
    unsetInvoice(context) {
      context.commit('unsetInvoice')
    }
  }
}

export default invoice
